/** Dossier virtuel client — messages reportés (métadonnée Aurélia, pas IMAP). */
export const AURELIA_SNOOZED_FOLDER = "__aurelia_snoozed__";

export const SNOOZED_FOLDER_LABEL = "En attente";

export function isSnoozedNavFolder(name: string): boolean {
  return name === AURELIA_SNOOZED_FOLDER;
}

export type MailSnoozeEntry = {
  uid: number;
  folder: string;
  holdFolder?: string | null;
  /** UID réel dans le dossier hold IMAP (peut différer après déplacement). */
  holdUid?: number | null;
  until: string;
  subject: string | null;
};

export type MailSnoozeWoke = {
  uid: number;
  folder: string;
  holdFolder?: string | null;
  holdUid?: number | null;
  subject: string | null;
};

export function snoozeEntryKey(folder: string, uid: number): string {
  return `${folder}\0${uid}`;
}
